import React from 'react';
import cn from 'classnames';

import CategoryBreadcrumbs from 'brandComponents/Breadcrumbs';
import Grid from 'brandComponents/Grid';
import ProductListFiltersControl from 'brandComponents/ProductListFilterControl';
import ProductListGridContainer from 'brandComponents/ProductListGridContainer';
import ProductListHeading from 'brandComponents/ProductListHeading';

import styles from './CategoryDefault.module.scss';

const CategoryDefault = () => {
	return (
		<Grid classNames={cn(styles['categoryDefault'], 'cf-grid', 'g-y-none')} fluid>
			<Grid.Row classNames={styles['categoryDefault__productHeading']} edgeToEdge>
				<Grid.Column edgeToEdge lg={6} classNames={styles['categoryDefault__productHeading-column']} >
					<ProductListHeading />
				</Grid.Column>
				<Grid.Column edgeToEdge lg={6} classNames={styles['categoryDefault__productHeading-filters__wrapper']}>
					<ProductListFiltersControl />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column>
					<ProductListGridContainer />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column>
					<CategoryBreadcrumbs />
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default CategoryDefault;